import _possibleConstructorReturn from "/home/jenkins/workspace/MyAccount_master/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/jenkins/workspace/MyAccount_master/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _get from "/home/jenkins/workspace/MyAccount_master/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/get";
import _inherits from "/home/jenkins/workspace/MyAccount_master/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _regeneratorRuntime from "/home/jenkins/workspace/MyAccount_master/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/home/jenkins/workspace/MyAccount_master/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/home/jenkins/workspace/MyAccount_master/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jenkins/workspace/MyAccount_master/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import { createPkce } from "./crypto";
export function createGrant(client_type) {
  switch (client_type) {
    case "Implicit":
      return new ImplicitGrant();

    case "AuthorizationCode":
      return new AuthorizationCodeGrant();

    case "AuthorizationCodeWithProofKey":
      return new AuthorizationCodeWithProofKeyGrant();
  }

  throw new Error("Unsupported '" + client_type + "' client type.");
}

var ImplicitGrant =
/*#__PURE__*/
function () {
  function ImplicitGrant() {
    _classCallCheck(this, ImplicitGrant);
  }

  _createClass(ImplicitGrant, [{
    key: "enrich",
    value: function () {
      var _enrich = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee(query) {
        var state;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                state = {
                  response_type: "id_token token",
                  response_mode: "fragment"
                };
                Object.assign(query, state);
                return _context.abrupt("return", state);

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function enrich(_x) {
        return _enrich.apply(this, arguments);
      }

      return enrich;
    }()
  }]);

  return ImplicitGrant;
}();

var AuthorizationCodeGrant =
/*#__PURE__*/
function () {
  function AuthorizationCodeGrant() {
    _classCallCheck(this, AuthorizationCodeGrant);
  }

  _createClass(AuthorizationCodeGrant, [{
    key: "enrich",
    value: function () {
      var _enrich2 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2(query) {
        var state;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                state = {
                  response_type: "code",
                  response_mode: "query"
                };
                Object.assign(query, state);
                return _context2.abrupt("return", state);

              case 3:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      function enrich(_x2) {
        return _enrich2.apply(this, arguments);
      }

      return enrich;
    }()
  }]);

  return AuthorizationCodeGrant;
}();

var AuthorizationCodeWithProofKeyGrant =
/*#__PURE__*/
function (_AuthorizationCodeGra) {
  _inherits(AuthorizationCodeWithProofKeyGrant, _AuthorizationCodeGra);

  function AuthorizationCodeWithProofKeyGrant() {
    _classCallCheck(this, AuthorizationCodeWithProofKeyGrant);

    return _possibleConstructorReturn(this, _getPrototypeOf(AuthorizationCodeWithProofKeyGrant).apply(this, arguments));
  }

  _createClass(AuthorizationCodeWithProofKeyGrant, [{
    key: "enrich",
    value: function () {
      var _enrich3 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee3(query) {
        var state, pkce;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return _get(_getPrototypeOf(AuthorizationCodeWithProofKeyGrant.prototype), "enrich", this).call(this, query);

              case 2:
                state = _context3.sent;
                _context3.next = 5;
                return createPkce();

              case 5:
                pkce = _context3.sent;
                state["code_verifier"] = pkce.code_verifier;
                query["code_challenge"] = pkce.code_challenge;
                query["code_challenge_method"] = pkce.code_challenge_method;
                return _context3.abrupt("return", state);

              case 10:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function enrich(_x3) {
        return _enrich3.apply(this, arguments);
      }

      return enrich;
    }()
  }]);

  return AuthorizationCodeWithProofKeyGrant;
}(AuthorizationCodeGrant);